import { render } from "./App.vue?vue&type=template&id=f342a252"
const script = {}
script.render = render

export default script